import React, { useContext, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Button, CircularProgress, TextField, Typography } from "@mui/material";
import { clearDeliveryDetails } from "../utils/cleardeliverydetails";
import Logo from "../assets/company-logo.png";
import "./Login.css";
import BuIcon from "../assets/b-arrow.png";
import StoreLocationPopup from "../component/ModalComp/StoreLocationPopup";
import { useNavigate, useParams } from "react-router-dom";
import LocationContext from "../context/LocationContext";
import ErrorContext from "../context/ErrorContext";
import axiosApiFunction from "../utils/axiosapifunc";
import { decryptData, parseDecryptedData } from "../utils/decryptparams";
import { showApiErrorToast } from "../utils/toastHelper";
import AppStore from '../assets/app-store.png'
import PlayStore from '../assets/play-store.png'

// const decryptData = (encryptedData, key) => {
//     const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedData); // Decode Base64 to bytes
//     const ivLength = 16; // AES block size
//     const iv = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(0, ivLength / 4)); // Extract IV
//     const ciphertext = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(ivLength / 4));

//     const decrypted = CryptoJS.AES.decrypt(
//         { ciphertext },
//         CryptoJS.enc.Utf8.parse(key), // Parse the key
//         {
//             iv,
//             mode: CryptoJS.mode.CBC,
//             padding: CryptoJS.pad.Pkcs7,
//         }
//     );

//     return decrypted.toString(CryptoJS.enc.Utf8); // Convert decrypted data to UTF-8 string
// };

// const parseDecryptedData = (decryptedData) => {
//     const params = new URLSearchParams(decryptedData);

//     const lid = params.get('lid');
//     const cid = params.get('cid');
//     const tblid = params.get('tblid');
//     const tblname = params.get('tblname');
//     // return { lid, cid };
//     return { lid, cid, tblid, tblname };
// };

function LogIn() {
    const navigate = useNavigate();
    const [showOtpInput, setShowOtpInput] = useState(false);
    const [nameError, setNameError] = useState('');
    const [mobileError, setMobileError] = useState('');
    const [storeError, setStoreError] = useState('');
    const [otpError, setOtpError] = useState('');
    const [selectedLocation, setSelectedLocation] = useState("");
    const [showLocationPopup, setShowLocationPopup] = useState(false);
    const [storesDetail ,setStoresDetail] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const locationCtx = useContext(LocationContext);
    const {apiError, setApiError, clearApiError}= useContext(ErrorContext);
    // const isOTPEnabled = false; //this is static
    const [isOTPEnabled, setIsOTPEnabled] = useState(1);

    const userToken = JSON.parse(localStorage.getItem('tokenData'))?.token;
    const companyId = JSON.parse(localStorage.getItem('companyId'));
    const [parsedData, setParsedData] = useState(null);
    const {id} = useParams();
    
    useEffect(() => {
        if (!id) {
            window.location.href = "https://www.billberrypos.com/";
            return;
        }
    }, [id]);

      const handleOpenLocationPopup = () => {
        setShowLocationPopup(true);  // Open the pop-up when the user clicks the field
    };

    // const handleWrongNumberClick = () => {
    //     setShowOtpInput(false); // Return to the initial input fields
    // };

    // const handleResendOtp = () => {
    //     onOtpSendHandle();
    // };

    const handleLocationSelect = (location) => {
        const existingLocation = JSON.parse(localStorage.getItem('locationData'));

        if(existingLocation) {
            if(existingLocation.locationid != location.locationid) {
                localStorage.removeItem("cartData");
            }
        }
        setSelectedLocation(location);  // Set the selected location
        setStoreError("");
        locationCtx.handleLocationChange(location);
        localStorage.setItem("locationId", Number(location.locationid));
        localStorage.setItem('locationData', JSON.stringify(location));
        setIsOTPEnabled(location?.isotprequired ? location?.isotprequired : 0); 
        setShowLocationPopup(false);  // Close the pop-up
    };

    const [formData, setFormData] = useState({
        username: "",
        usermobile: "",
    });

    const [counter, setCounter] = useState(30);

    // const handleInputChange = (e) => {
    //     setNameError('');
    //     setMobileError('');
    //     setOtpError('');
    //     const { name, value } = e.target;
    //     if (name === 'usermobile') {
    //         if (/^\d*$/.test(value) && value.length <= 10) {
    //           setFormData((prevState) => ({ ...prevState, [name]: value }));
    //         }
    //       } else {
    //         setFormData((prevState) => ({ ...prevState, [name]: value }));
    //       }
    // }
    // const handleOtp = (otpValue) => {
    //     setFormData((prevState) => ({ ...prevState, otp: otpValue }));
    //     setOtpError('');
    // };

    // const validateInput = (data) => {
    //     let isValid = true;
    //     if(!(/^[A-Za-z0-9 ]{3,50}$/.test(data.username))){
    //         setNameError('Name should be atleast 3 to 50 characters long');
    //         isValid = false;
    //     } else {
    //         setNameError('');
    //     }

    //     if(!(/^[6-9]\d{9}$/.test(data.usermobile))){
    //         setMobileError('Enter valid mobile number');
    //         isValid = false;
    //     } else {
    //         setMobileError('');
    //     }

    //     if (!parsedData?.lid && !selectedLocation) {
    //         setStoreError('Please select a store location');
    //         isValid = false;
    //     } else {
    //         setStoreError('');
    //     }

    //     return isValid;
    // }

    const handleDirectLogin = async () => {
        clearApiError();
        let isValid = true;
        // if(!(/^[A-Za-z0-9 ]{3,50}$/.test(data.username))){
        //     setNameError('Name should be atleast 3 to 50 characters long');
        //     isValid = false;
        // } else {
        //     setNameError('');
        // }

        // if(!(/^[6-9]\d{9}$/.test(data.usermobile))){
        //     setMobileError('Enter valid mobile number');
        //     isValid = false;
        // } else {
        //     setMobileError('');
        // }

        if (!parsedData?.lid && !selectedLocation) {
            setStoreError('Please select a store location');
            isValid = false;
        } else {
            setStoreError('');
        }

        if(!isValid) return;
        if (isLoading) return;

        navigate('/catalogue');
        // setIsLoading(true);
        
        // try {
        //     let fetchUserData = formData ? formData : JSON.parse(localStorage.getItem('userData'));

        //     const response = await axiosApiFunction('post', '/api/v1/login', {}, "", {
        //         "companyid": companyId,
        //         "mobileno": formData.usermobile,
        //         "otp": fetchUserData.otp
        //     });

        //     localStorage.setItem('tokenData', JSON.stringify(response.data));
        //     localStorage.setItem('userData', JSON.stringify(formData));

        //     const selected = storesDetail.filter((store) => store.locationid == parsedData.lid);

        //     if(selectedLocation) {
        //         localStorage.setItem('locationData', JSON.stringify(selectedLocation));
        //         locationCtx.handleLocationChange(selectedLocation);
        //     } else {
        //         localStorage.setItem('locationData', JSON.stringify(selected[0]));
        //         locationCtx.handleLocationChange(selected[0]);
        //     }

        //     navigate('/catalogue');
        // } catch (error) {
        //     setApiError(error.message);
        // } finally {
        //     setIsLoading(false);
        // }
    };

    // const onOtpSendHandle = async() => {
    //     clearApiError();
    //     if (!validateInput(formData)) {
    //         return;
    //     }

    //     if(isLoading) return;

    //     setIsLoading(true);

    //     try {    
    //         const response = await axiosApiFunction('POST', '/api/v1/sendotp', { phoneno: formData.usermobile, locationid: selectedLocation.locationid, companyid: companyId });
    //         if (response.data.success === 1) {
    //           setShowOtpInput(true);
    //           setCounter(30);
    //         } else {
    //           setApiError(response.data.msg);
    //         }
    //       } catch (error) {
    //         setApiError(error.message);
    //       } finally {
    //         setIsLoading(false);
    //       }
    // }

    // const handleSubmit = async() => {
    //     if(isLoading) return;
    //     setIsLoading(true);
    //     let fetchUserData = formData ? formData : JSON.parse(localStorage.getItem('userData'));
    //     if(formData.otp?.length < 6){
    //         setOtpError("Please Enter Correct OTP");
    //         setIsLoading(false);
    //         return;
    //     }
        
    //     if(formData?.usermobile !== fetchUserData?.usermobile){
    //         localStorage.removeItem('cartData');
    //     }
    //     localStorage.removeItem('userData');

    //     try {
    //         const response = await axiosApiFunction('post', '/api/v1/verifyotp', { phoneno: fetchUserData.usermobile, otp: fetchUserData.otp });
    //         if (response.data.success === 1) {
    //             const tokenResp = await axiosApiFunction('post', '/api/v1/login', {}, "",{ 
    //                 "companyid": companyId,
    //                 "mobileno":formData.usermobile,
    //                 "otp": fetchUserData.otp
    //             });
    //             // console.log('tokenrespp>>>>>>>>', tokenResp);
    //             // if(tokenResp.data.data.phoneno === formData.usermobile){
    //                 localStorage.setItem('tokenData', JSON.stringify(tokenResp.data));
    //                 localStorage.setItem('userData', JSON.stringify(formData));
    //                 localStorage.setItem('locationData', JSON.stringify(selectedLocation));
    //                 locationCtx.handleLocationChange(selectedLocation);
    //                 navigate('/catalogue');
    //             // }
    //         } else {
    //             setOtpError(response.data.msg);
    //             setIsLoading(false);
    //         }
    //     } catch (error) {
    //         setApiError(error.message);
    //     } finally {
    //         setIsLoading(false);
    //     }
    // }

    useEffect(() => {
        let timer;
        if (showOtpInput && counter > 0) {
            timer = setInterval(() => {
                setCounter((prevCounter) => prevCounter - 1);
            }, 1000);
        } else if (counter === 0) {
            clearInterval(timer);
        }
        return () => clearInterval(timer);
    }, [showOtpInput, counter]);

    useEffect(() => {
        if (!id) return;

        // const key = "ASdis83!8217o9ASdis83!8217o9ASdi"; // Must be 32 bytes for AES-256
        const encodedId = encodeURIComponent(id);
        localStorage.setItem("encryptedData", encodedId);
        const encryptedData = id;

        try {
            if(encryptedData) {
                const decryptedData = decryptData(encryptedData);
                // console.log(decryptedData);

                if (!decryptedData) {
                    throw new Error("Decrypted data is empty or undefined");
                }
                
                const parsed = parseDecryptedData(decryptedData);
                //console.log(parsed);
                
                // const parsed = { cid: 81, lid: "" };
                setParsedData(parsed);
    
                if (parsed) {
                    localStorage.removeItem("tblid");
                    localStorage.removeItem("tblname");
                    localStorage.removeItem("order-time");
                    if (parsed.cid) {
                        localStorage.setItem("companyId", Number(parsed.cid));
                        sessionStorage.setItem("companyId", Number(parsed.cid)); // Backup for iOS Safari
                    }
                    if (parsed.lid) {
                        localStorage.setItem("locationId", Number(parsed.lid));
                        localStorage.setItem("isLocationAvailable", true);    
                        sessionStorage.setItem("locationId", Number(parsed.lid)); // Backup for iOS Safari                
                    } else {
                        localStorage.setItem("isLocationAvailable", false);
                    }
                    if (parsed.tblid) {
                        const tableId = Number(parsed.tblid);
                        localStorage.setItem("tblid", tableId);
                        sessionStorage.setItem("tblid", tableId); // Backup for iOS Safari

                        // Verify write completed (critical for iOS Safari first-time scans)
                        const verifyTableId = localStorage.getItem("tblid");
                        if (!verifyTableId || verifyTableId === "0" || verifyTableId === "null") {
                            console.warn("Table ID not persisted properly on first write, retrying...");
                            localStorage.setItem("tblid", tableId);
                        }
                    } else {
                        // Explicitly set to 0 if no table order
                        localStorage.setItem("tblid", 0);
                        sessionStorage.setItem("tblid", 0);
                    }
                    
                    if (parsed.tblname) {
                        localStorage.setItem("tblname", JSON.stringify(parsed.tblname));
                        sessionStorage.setItem("tblname", JSON.stringify(parsed.tblname)); // Backup for iOS Safari
                    }
                } else {
                    console.warn("No parsed data available.");
                }

                if(parsed.lid) {
                    const existingLocation = JSON.parse(localStorage.getItem('locationData'));

                    if(existingLocation) {
                        if(Number(existingLocation.locationid) != Number(parsed.lid)) {
                            localStorage.removeItem("cartData");
                            clearDeliveryDetails();
                        }
                    }
                    navigate("/catalogue");
                    return; // Skip getStoresDetails — Home.js will fetch stores
                }
            }
        } catch (error) {
            console.error("Decryption failed:", error);
            window.location.href = "https://www.billberrypos.com/";
        }

        async function getStoresDetails() {
            try {
                setIsLoading(true);

                const companyId = JSON.parse(localStorage.getItem('companyId'));

                const storesDetails = await axiosApiFunction(
                    "get",
                    "/api/v1/getbopisstores",
                    { companyid: companyId },
                );
                //console.log(storesDetails.data);
                //setSelectedLocation(storesDetails.data[0]);
                //locationCtx.handleLocationChange(storesDetails.data[0]);
                if(storesDetails.data.length == 1) {
                    localStorage.setItem('locationData', JSON.stringify(storesDetails.data[0]));
                    locationCtx.handleLocationChange(storesDetails.data[0]);
                }
                setStoresDetail(storesDetails.data);
                setIsOTPEnabled(storesDetails.data[0]?.isotprequired ? storesDetails.data[0]?.isotprequired : 0);

                if(storesDetails.data.length == 1) {
                    setSelectedLocation(storesDetails.data[0]);  // Set the selected location
                }
            } catch (error) {
                showApiErrorToast('/api/v1/getbopisstores', error, 'Failed to load stores (Login page)');
                setApiError(error.message);
            } finally {
                setIsLoading(false);
            }
        }

        getStoresDetails();
    }, []);

    if (!id) {
        return null; // Prevent rendering if id is invalid (redirect happens)
    }

    return (
        parsedData && Object.keys(parsedData).length > 0 && (
        <div className="login-page">
            <div className="main-box">
                <div className="left-part-login">
                    <div className="logo">
                        <img src={Logo} width="100%" loading="eager"/>
                    </div>
                    {/* <div className="playstore-links-mainbox">
                        <div className="play-store-img">
                            <a href="https://apps.apple.com/in/app/la-milano-pizzeria/id6467398149">
                                <img src={AppStore} />
                            </a>
                        </div>
                        <div className="app-store-img">
                            <a href="https://play.google.com/store/apps/details?id=delivery.fab.lamilanopizzeria.android">
                                <img src={PlayStore} />
                            </a>
                        </div>
                    </div> */}
                </div>
                <Box className="box">
                    {/* {!showOtpInput ? (
                        <> */}
                    <Typography
                        variant="h4"
                        padding={3}
                        textAlign={"center"}
                        className="login-header-text"
                    >
                        LET'S START ORDERING
                    </Typography>
                    {/* <TextField
                                fullWidth
                                id="fullWidth"
                                type="text"
                                margin="normal"
                                placeholder="Enter Your Name"
                                name="username"
                                value={formData.username}
                                onChange={(e) => handleInputChange(e)}
                                sx={{ border: "none", outline: "none" }}
                                inputProps={{
                                    autoComplete: "off",
                                }}
                            />
                            <span style={{ color: "red", fontSize: "0.8rem" }}>{nameError}</span>
                            <TextField
                                fullWidth
                                id="fullWidth"
                                type="tel"
                                margin="normal"
                                placeholder="Enter 10 Digit Mobile Number"
                                name="usermobile"
                                inputMode="numeric"
                                sx={{ border: "none", outline: "none" }}
                                inputProps={{
                                    maxLength: 10,
                                    autoComplete: "off",
                                }}
                                value={formData.usermobile}
                                onChange={(e) => handleInputChange(e)}
                            />
                            <span style={{ color: "red", fontSize: "0.8rem" }}>{mobileError}</span> */}
                    {/* {!(JSON.parse(localStorage.getItem("isLocationAvailable")) == true) && (
                        <> */}
                            <TextField
                                fullWidth
                                margin="normal"
                                placeholder="Select Store Location"
                                value={selectedLocation.name}
                                onClick={handleOpenLocationPopup} // Open the pop-up
                                sx={{ border: "none", outline: "none" }}
                                InputProps={{
                                    readOnly: true, // Make the field read-only so the user can't type
                                }}
                                className="store-input"
                            />
                            <span style={{ color: "red", fontSize: "0.8rem" }}>{storeError}</span>
                        {/* </>
                    )} */}

                    <br />
                    {/* {apiError && (
                                <span>
                                    {apiError}
                                    <br />
                                </span>
                            )} */}
                    <Button
                        sx={{
                            marginTop: 3,
                            borderRadius: 10,
                            background: "#FF3A44",
                        }}
                        variant="contained"
                        color="success"
                        onClick={() => {
                            handleDirectLogin();
                        }}
                        className="login-button-text"
                    >
                        {!isLoading ? (
                            <span className="login-button-icon">
                                Start Ordering
                                <img src={BuIcon} alt="BuIcon" loading="eager"/>
                            </span>
                        ) : (
                            <CircularProgress color="inherit" />
                        )}
                    </Button>
                    {/* </>
                    ) : (
                        <div>
                            <Typography variant="h4" padding={3} textAlign={"center"}>
                                ENTER YOUR OTP
                            </Typography>
                            {selectedLocation?.name && (
                                <Typography
                                    variant="body1"
                                    padding={2}
                                    textAlign={"center"}
                                    color="primary"
                                    sx={{ color: "gray", fontWeight: "600" }}
                                >
                                    {selectedLocation?.name}
                                </Typography>
                            )}
                            <GetOtp length={6} onOtpChange={handleOtp} />
                            <span style={{ color: "red" }}>{otpError}</span>
                            <br />
                            <Button
                                sx={{
                                    marginTop: 3,
                                    borderRadius: 10,
                                    background: "#FF3A44",
                                }}
                                variant="contained"
                                color="success"
                                onClick={handleSubmit}
                            >
                                {!isLoading ? (
                                    <span className="login-button-icon">
                                        Submit <img src={BuIcon} />
                                    </span>
                                ) : (
                                    <CircularProgress color="inherit" />
                                )}
                            </Button>
                            <Typography
                                variant="body2"
                                color="primary"
                                sx={{ marginTop: 2, cursor: "pointer" }}
                                onClick={handleWrongNumberClick}
                            >
                                Wrong number?
                            </Typography>
                            {counter > 0 ? (
                                <Typography variant="body2" sx={{ marginTop: 2 }}>
                                    Resend OTP in: {counter}s
                                </Typography>
                            ) : (
                                <Typography
                                    variant="body2"
                                    color="primary"
                                    sx={{ marginTop: 2, cursor: "pointer" }}
                                    onClick={handleResendOtp}
                                >
                                    Resend OTP
                                </Typography>
                            )}
                        </div>
                    )} */}
                </Box>
            </div>
            <StoreLocationPopup
                open={showLocationPopup}
                onClose={() => setShowLocationPopup(false)} // Close the pop-up
                onSelectLocation={handleLocationSelect} // Handle location selection
                locations={storesDetail}
            />
            {/* <Footer /> */}
        </div>
        )
    );
}

export default LogIn;
